export default __webpack_public_path__ + "static/media/inicio.dcceecf5.svg";